// extracted by mini-css-extract-plugin
export default {"footer":"LSuWBRugFlmSYfu3X_PI","container":"DiKOzygMFsbkEzViN3RE","navigation":"gJUaX3K6Xu_ywN7aclZb","collapse":"ztB5LHNG8oJJDdhPle5T"};